import React from "react";

import "./ReikiHeader.css";

function ReikiHeader() {
  return (
    <div className="reiki_header_page">
      <div className="reiki_header_container">
        <h1>Reiki</h1>
      </div>
    </div>
  );
}

export default ReikiHeader;
